import { render, staticRenderFns } from "./WelcomeComponent.vue?vue&type=template&id=1554659e&scoped=true&"
import script from "./WelcomeComponent.vue?vue&type=script&lang=ts&"
export * from "./WelcomeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeComponent.vue?vue&type=style&index=0&id=1554659e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554659e",
  null
  
)

export default component.exports